import React, { useState, useEffect } from 'react';

const navLinks = [
  { label: 'First Talk', href: '#first-talk' },
  { label: 'Social Media', href: '#social-media' },
  { label: 'Late Night', href: '#late-night' },
  { label: 'Fight', href: '#first-fight' },
  { label: 'Proposal', href: '#proposal' },
  { label: 'Birthday', href: '#birthday' },
  { label: 'Waiting', href: '#waiting' },
  { label: 'Eid', href: '#countdown' },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <>
      <nav style={{
        position: 'fixed', top: 0, left: 0, right: 0,
        zIndex: 1000,
        padding: scrolled ? '10px 24px' : '18px 24px',
        background: scrolled ? 'rgba(13,10,20,0.95)' : 'transparent',
        backdropFilter: scrolled ? 'blur(20px)' : 'none',
        borderBottom: scrolled ? '1px solid rgba(255,107,157,0.15)' : 'none',
        transition: 'all 0.4s ease',
        display: 'flex', alignItems: 'center', justifyContent: 'space-between',
      }}>
        {/* LOGO */}
        <a href="#hero" style={{ textDecoration: 'none', display: 'flex', alignItems: 'center', gap: 10 }}>
          <div style={{
            width: 42, height: 42,
            background: 'linear-gradient(135deg, #ff6b9d, #a855f7)',
            borderRadius: '12px',
            display: 'flex', alignItems: 'center', justifyContent: 'center',
            fontSize: 20, boxShadow: '0 4px 20px rgba(255,107,157,0.4)',
            flexShrink: 0,
          }}>💕</div>
          <div>
            <div style={{
              fontFamily: 'Poppins, sans-serif', fontWeight: 800, fontSize: 16,
              background: 'linear-gradient(135deg, #ff6b9d, #a855f7)',
              WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent',
              lineHeight: 1,
            }}>Our Timeline</div>
            <div style={{ fontFamily: 'Nunito, sans-serif', fontSize: 10, color: '#9b7ba8', letterSpacing: '0.1em' }}>
              Hassan & Fiza
            </div>
          </div>
        </a>

        {/* DESKTOP LINKS */}
        <div style={{ display: 'flex', gap: 6, alignItems: 'center' }} className="hide-mobile">
          {navLinks.map(l => (
            <a key={l.href} href={l.href} style={{
              fontFamily: 'Poppins, sans-serif', fontWeight: 500, fontSize: 13,
              color: '#e2c8d8', textDecoration: 'none', padding: '7px 12px',
              borderRadius: 50, transition: 'all 0.3s ease',
              border: '1px solid transparent',
            }}
            onMouseEnter={e => {
              e.target.style.background = 'rgba(255,107,157,0.1)';
              e.target.style.color = '#ff6b9d';
              e.target.style.borderColor = 'rgba(255,107,157,0.3)';
            }}
            onMouseLeave={e => {
              e.target.style.background = 'transparent';
              e.target.style.color = '#e2c8d8';
              e.target.style.borderColor = 'transparent';
            }}>{l.label}</a>
          ))}
        </div>

        {/* HAMBURGER */}
        <button className="hide-desktop" onClick={() => setOpen(!open)} style={{
          background: 'rgba(255,107,157,0.1)', border: '1px solid rgba(255,107,157,0.3)',
          borderRadius: 10, padding: '8px 10px', cursor: 'pointer',
          display: 'flex', flexDirection: 'column', gap: 5, transition: 'all 0.3s',
        }}>
          {[0,1,2].map(i => (
            <div key={i} style={{
              width: 22, height: 2,
              background: open ? (i === 1 ? 'transparent' : '#ff6b9d') : '#ff6b9d',
              borderRadius: 2, transition: 'all 0.3s ease',
              transform: open ? (i === 0 ? 'rotate(45deg) translate(5px,5px)' : i === 2 ? 'rotate(-45deg) translate(5px,-5px)' : 'none') : 'none',
            }} />
          ))}
        </button>
      </nav>

      {/* MOBILE MENU */}
      <div style={{
        position: 'fixed', top: 0, left: 0, right: 0, bottom: 0,
        background: 'rgba(13,10,20,0.98)',
        backdropFilter: 'blur(20px)',
        zIndex: 999,
        display: 'flex', flexDirection: 'column', alignItems: 'center', justifyContent: 'center',
        gap: 8,
        transform: open ? 'translateX(0)' : 'translateX(100%)',
        transition: 'transform 0.4s cubic-bezier(0.25, 0.46, 0.45, 0.94)',
      }}>
        <div style={{ fontSize: 40, marginBottom: 20 }}>💕</div>
        {navLinks.map((l, i) => (
          <a key={l.href} href={l.href} onClick={() => setOpen(false)} style={{
            fontFamily: 'Poppins, sans-serif', fontWeight: 600, fontSize: 22,
            color: '#e2c8d8', textDecoration: 'none', padding: '12px 40px',
            borderRadius: 12, width: '80%', textAlign: 'center',
            border: '1px solid rgba(255,107,157,0.15)',
            background: 'rgba(255,107,157,0.05)',
            transition: 'all 0.3s ease',
            animationDelay: `${i * 0.05}s`,
          }}
          onMouseEnter={e => {
            e.target.style.background = 'rgba(255,107,157,0.15)';
            e.target.style.color = '#ff6b9d';
          }}
          onMouseLeave={e => {
            e.target.style.background = 'rgba(255,107,157,0.05)';
            e.target.style.color = '#e2c8d8';
          }}>{l.label}</a>
        ))}
      </div>
    </>
  );
}